// 获取云游戏
export const FETCH_CLOUDGAMES_APPS = 'FETCH_CLOUDGAMES_APPS'
